<template>
	<div>
		<a-row :gutter="[16,16]" style="margin: 20px;text-align: center;">
			<!-- 访问量 -->
			<a-col :span="12">
				<a-row v-if="visitData" style="background: #fff;">
					<a-col :span="6">
						<a-statistic class="count" :value="visitData.count.all" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">访问量</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="今日" :value="visitData.count.today" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="7日" :value="visitData.count.week" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="30日" :value="visitData.count.month" />
					</a-col>
					<a-col :span="24">
						<a-spin :spinning="loading.visitData" :style="'height:' + height + 'px'" style="padding: 30px 60xp 60px;">
							<v-chart :forceFit="true" :height="height" :data="visitData.data" :padding="[30,60,60,60]">
								<v-tooltip />
								<v-axis />
								<v-smooth-line position="title*value" :size="2" />
								<v-point position="title*value" />
							</v-chart>
						</a-spin>
					</a-col>
				</a-row>
			</a-col>

			<!-- 微信用户 -->
			<a-col :span="12">
				<a-row v-if="usersData" style="background: #fff;">
					<a-col :span="6">
						<a-statistic class="count" :value="usersData.count.all" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">微信用户</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="今日" :value="usersData.count.today" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="7日" :value="usersData.count.week" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="30日" :value="usersData.count.month" />
					</a-col>
					<a-col :span="24">
						<a-spin :spinning="loading.usersData" :style="'height:' + height + 'px'" style="padding: 30px 60xp 60px;">
							<v-chart :forceFit="true" :height="height" :data="usersData.data" :padding="[30,60,60,60]">
								<v-tooltip />
								<v-axis />
								<v-smooth-line position="title*value" :size="2" />
								<v-point position="title*value" />
							</v-chart>
						</a-spin>
					</a-col>
				</a-row>
			</a-col>

			<!-- 会员统计 -->
			<!-- <a-col :span="12">
				<a-row v-if="memberData" style="background: #fff;">
					<a-col :span="6">
						<a-statistic class="count" :value="memberData.count.one" style="font-weight: 700;" :valueStyle="{ color: '#3f8600' }">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">普通会员</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" :value="memberData.count.two" style="font-weight: 700;" :valueStyle="{ color: '#3f8600' }">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">初级会员</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" :value="memberData.count.three" style="font-weight: 700;" :valueStyle="{ color: '#3f8600' }">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">中级会员</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" :value="memberData.count.four" style="font-weight: 700;" :valueStyle="{ color: '#3f8600' }">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">高级会员</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="24">
						<a-spin :spinning="loading.memberData" :style="'height:' + height + 'px'" style="padding: 30px 60xp 60px;">
							<v-chart :forceFit="true" :height="200" :data="memberData.data" :padding="[30,60,60,60]">
								<v-tooltip :showTitle="false" dataKey="name*value" />
								<v-axis />
								<v-legend dataKey="name" />
								<v-pie position="value" color="name" />
								<v-coord type="theta" />
							</v-chart>
						</a-spin>
					</a-col>
				</a-row>
			</a-col> -->

			<!-- 充值金额 -->
			<!-- <a-col :span="12">
				<a-row v-if="rechargeData" style="background: #fff;">
					<a-col :span="6">
						<a-statistic class="count" :value="rechargeData.count.all" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;"
						 suffix="元">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">充值金额</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="今日" :value="rechargeData.count.today" suffix="元" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="7日" :value="rechargeData.count.week" suffix="元" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="30日" :value="rechargeData.count.month" suffix="元" />
					</a-col>
					<a-col :span="24">
						<a-spin :spinning="loading.rechargeData" :style="'height:' + height + 'px'" style="padding: 30px 60xp 60px;">
							<v-chart :forceFit="true" :height="height" :data="rechargeData.data" :padding="[30,60,60,60]">
								<v-tooltip />
								<v-axis />
								<v-smooth-line position="title*value" :size="2" />
								<v-point position="title*value" />
							</v-chart>
						</a-spin>
					</a-col>
				</a-row>
			</a-col> -->

			<!-- 订单数量 -->
			<a-col :span="12">
				<a-row v-if="salesNumberData" style="background: #fff;">
					<a-col :span="6">
						<a-statistic class="count" :value="salesNumberData.count.all" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;"
						 suffix="单">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">订单数量</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="今日" :value="salesNumberData.count.today" suffix="单" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="7日" :value="salesNumberData.count.week" suffix="单" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="30日" :value="salesNumberData.count.month" suffix="单" />
					</a-col>
					<a-col :span="24">
						<a-spin :spinning="loading.salesNumberData" :style="'height:' + height + 'px'" style="padding: 30px 60xp 60px;">
							<v-chart :forceFit="true" :height="height" :data="salesNumberData.data" :padding="[30,60,60,60]">
								<v-tooltip />
								<v-axis />
								<v-smooth-line position="title*value" :size="2" />
								<v-point position="title*value" />
							</v-chart>
						</a-spin>
					</a-col>
				</a-row>
			</a-col>

			<!-- 订单金额 -->
			<a-col :span="12">
				<a-row v-if="orderStoreAmountData" style="background: #fff;">
					<a-col :span="6">
						<a-statistic class="count" :value="orderStoreAmountData.count.all" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;"
						 suffix="元">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">订单金额</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="今日" :value="orderStoreAmountData.count.today" suffix="元" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="7日" :value="orderStoreAmountData.count.week" suffix="元" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="30日" :value="orderStoreAmountData.count.month" suffix="元" />
					</a-col>
					<a-col :span="24">
						<a-spin :spinning="loading.orderStoreAmountData" :style="'height:' + height + 'px'" style="padding: 30px 60xp 60px;">
							<v-chart :forceFit="true" :height="height" :data="orderStoreAmountData.data" :padding="[30,60,60,60]">
								<v-tooltip />
								<v-axis />
								<v-smooth-line position="title*value" :size="2" />
								<v-point position="title*value" />
							</v-chart>
						</a-spin>
					</a-col>
				</a-row>
			</a-col>

			<!-- 积分订单数量 -->
			<!-- <a-col :span="12">
				<a-row v-if="integralOrderData" style="background: #fff;">
					<a-col :span="6">
						<a-statistic class="count" :value="integralOrderData.count.all" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;"
						 suffix="单">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">积分订单数量</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="今日" :value="integralOrderData.count.today" suffix="单" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="7日" :value="integralOrderData.count.week" suffix="单" />
					</a-col>
					<a-col :span="6">
						<a-statistic class="count" title="30日" :value="integralOrderData.count.month" suffix="单" />
					</a-col>
					<a-col :span="24">
						<a-spin :spinning="loading.integralOrderData" :style="'height:' + height + 'px'" style="padding: 30px 60xp 60px;">
							<v-chart :forceFit="true" :height="height" :data="integralOrderData.data" :padding="[30,60,60,60]">
								<v-tooltip />
								<v-axis />
								<v-smooth-line position="title*value" :size="2" />
								<v-point position="title*value" />
							</v-chart>
						</a-spin>
					</a-col>
				</a-row>
			</a-col> -->

			<!-- 积分订单金额 -->
			<!-- <a-col :span="12">
				<a-row v-if="integralPayData" style="background: #fff;">
					<a-col :span="6">
						<a-statistic :value="integralPayData.count.all" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;"
						 class="count" suffix="积分">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">积分订单花费</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="6">
						<a-statistic title="今日" :value="integralPayData.count.today" suffix="积分" class="count" />
					</a-col>
					<a-col :span="6">
						<a-statistic title="7日" :value="integralPayData.count.week" suffix="积分" class="count" />
					</a-col>
					<a-col :span="6">
						<a-statistic title="30日" :value="integralPayData.count.month" suffix="积分" class="count" />
					</a-col>
					<a-col :span="24">
						<a-spin :spinning="loading.integralPayData" :style="'height:' + height + 'px'" style="padding: 30px 60xp 60px;">
							<v-chart :forceFit="true" :height="height" :data="integralPayData.data" :padding="[30,60,60,60]">
								<v-tooltip />
								<v-axis />
								<v-smooth-line position="title*value" :size="2" />
								<v-point position="title*value" />
							</v-chart>
						</a-spin>
					</a-col>
				</a-row>
			</a-col> -->


			<!-- 门店销量排行 -->
			<!-- <a-col :span="12">
				<a-row v-if="integralPayData" style="background: #fff;">
					<a-col :span="24">
						<a-statistic value="TOP 10" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;" class="count">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">门店销量排行</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="24" style="padding: 20px;">
						<a-spin :spinning="loading.rankData" style="padding: 30px 60xp 60px;height: 260px;">
							<div v-for="(item,index) in rankData.store" :key="index" style="display: flex;justify-content: space-between;">
								<div style="margin-bottom: 5px;width: 60%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;text-align: left;">
									<span style="border-radius: 50%;display: inline-block;width: 22px;margin-right: 10px;font-weight: 700;text-align: center;" :style="index < 3 ? 'background:#ffc53d' : 'background:#f0f0f0'">{{index + 1}}</span>
									<strong>{{item.name}}</strong>
								</div>
								<div style="width: 35%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;text-align: right;">{{item.count}} 单 <span style="font-weight: 700;font-size: 16px;">{{item.value}}</span> 元</div>
							</div>
						</a-spin>
					</a-col>
				</a-row>
			</a-col> -->

			<!-- 会员消费排行 -->
			<!-- <a-col :span="12">
				<a-row v-if="integralPayData" style="background: #fff;">
					<a-col :span="24">
						<a-statistic value="TOP 10" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;" class="count">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">会员消费排行</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="24" style="padding: 20px;">
						<a-spin :spinning="loading.rankData" style="padding: 30px 60xp 60px;height: 260px;">
							<div v-for="(item,index) in rankData.member" :key="index" style="display: flex;justify-content: space-between;">
								<div style="margin-bottom: 5px;width: 60%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;text-align: left;">
									<span style="border-radius: 20px;display: inline-block;width: 20px;margin-right: 10px;font-weight: 700;text-align: center;" :style="index < 3 ? 'background:#ffc53d' : 'background:#f0f0f0'">{{index + 1}}</span>
									<strong>{{item.name}}</strong>
								</div>
								<div style="width: 35%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;text-align: right;">{{item.count}} 单 <span style="font-weight: 700;font-size: 16px;">{{item.value}}</span> 元</div>
							</div>
						</a-spin>
					</a-col>
				</a-row>
			</a-col> -->

			<!-- 商品销量排行 -->
			<!-- <a-col :span="12">
				<a-row v-if="integralPayData" style="background: #fff;">
					<a-col :span="24">
						<a-statistic value="TOP 10" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;" class="count">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">商品销量排行</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="24" style="padding: 20px;">
						<a-spin :spinning="loading.rankData" style="padding: 30px 60xp 60px;height: 260px;">
							<div v-for="(item,index) in rankData.goods" :key="index" style="display: flex;justify-content: space-between;">
								<div style="margin-bottom: 5px;width: 60%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;text-align: left;">
									<span style="border-radius: 20px;display: inline-block;width: 20px;margin-right: 10px;font-weight: 700;text-align: center;" :style="index < 3 ? 'background:#ffc53d' : 'background:#f0f0f0'">{{index + 1}}</span>
									<strong>{{item.name}}</strong>
								</div>
								<div style="width: 35%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;text-align: right;">{{item.count}} 单 <span style="font-weight: 700;font-size: 16px;">{{item.value}}</span> 元</div>
							</div>
						</a-spin>
					</a-col>
				</a-row>
			</a-col> -->
			
			<!-- 积分商品销量排行 -->
			<!-- <a-col :span="12">
				<a-row v-if="integralPayData" style="background: #fff;">
					<a-col :span="24">
						<a-statistic value="TOP 10" :valueStyle="{ color: '#3f8600' }" style="font-weight: 600;" class="count">
							<template #title>
								<span style="font-size: 20px;color:#3f8600 ;font-weight: 700;">积分商品销量排行</span>
							</template>
						</a-statistic>
					</a-col>
					<a-col :span="24" style="padding: 20px;">
						<a-spin :spinning="loading.rankData" style="padding: 30px 60xp 60px;height: 260px;">
							<div v-for="(item,index) in rankData.integral" :key="index" style="display: flex;justify-content: space-between;">
								<div style="margin-bottom: 5px;width: 60%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;text-align: left;">
									<span style="border-radius: 20px;display: inline-block;width: 20px;margin-right: 10px;font-weight: 700;text-align: center;" :style="index < 3 ? 'background:#ffc53d' : 'background:#f0f0f0'">{{index + 1}}</span>
									<strong>{{item.name}}</strong>
								</div>
								<div style="width: 35%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;text-align: right;">{{item.count}} 单 <span style="font-weight: 700;font-size: 16px;">{{item.value}}</span> 积分</div>
							</div>
						</a-spin>
					</a-col>
				</a-row>
			</a-col> -->

		</a-row>

	</div>
</template>
<script>
	import https from '../https.js'

	export default {
		data() {
			return {
				loading: {
					visitData: true,
					usersData: true,
					memberData: true,
					rechargeData: true,
					salesNumberData: true,
					orderStoreAmountData: true,
					integralOrderData: true,
					integralPayData: true,
					rankData: true
				},
				visitData: {
					count: {}
				},
				usersData: {
					count: {},
				},
				salesNumberData: {
					count: {},
				},
				orderStoreAmountData: {
					count: {}
				},
				memberData: {
					count: {},
				},
				integralOrderData: {
					count: {},
				},
				integralPayData: {
					count: {},
				},
				rechargeData: {
					count: {},
				},
				height: 200,
				rankData: {}
			};
		},
		created() {
			this.getVisitDcData()
			this.getUsersDcData()
			this.getSalesNumberData()
			this.getOrderStoreAmountData()
			this.getMemberData()
			this.getIntegralOrderData()
			this.getIntegralPayData()
			this.getRechargeData()
			this.getRank()
		},
		methods: {
			getVisitDcData() {
				https.post('/admin/index.php/admin/Index/dateCount', {
					type: 'visit',
				}).then((res) => {
					this.loading.visitData = false
					if (res.data.code == 1) {
						this.visitData = res.data
					}
				})
			},

			getUsersDcData() {
				https.post('/admin/index.php/admin/Index/dateCount', {
					type: 'users',
				}).then((res) => {
					this.loading.usersData = false
					if (res.data.code == 1) {
						this.usersData = res.data
					}
				})
			},

			getSalesNumberData() {
				https.post('/admin/index.php/admin/Index/dateCount', {
					type: 'salesNumber'
				}).then((res) => {
					this.loading.salesNumberData = false
					if (res.data.code == 1) {
						this.salesNumberData = res.data
					}
				})
			},

			getOrderStoreAmountData() {
				https.post('/admin/index.php/admin/Index/dateCount', {
					type: 'orderStoreAmount'
				}).then((res) => {
					this.loading.orderStoreAmountData = false
					if (res.data.code == 1) {
						this.orderStoreAmountData = res.data
					}
				})
			},

			getMemberData() {
				https.post('/admin/index.php/admin/Index/dateCount', {
					type: 'pieChart'
				}).then((res) => {
					this.loading.memberData = false
					if (res.data.code == 1) {
						this.memberData = res.data
					}
				})
			},

			getIntegralOrderData() {
				https.post('/admin/index.php/admin/Index/dateCount', {
					type: 'integral'
				}).then((res) => {
					this.loading.integralOrderData = false
					if (res.data.code == 1) {
						this.integralOrderData = res.data
					}
				})
			},

			getIntegralPayData() {
				https.post('/admin/index.php/admin/Index/dateCount', {
					type: 'integralMoney'
				}).then((res) => {
					this.loading.integralPayData = false
					if (res.data.code == 1) {
						this.integralPayData = res.data
					}
				})
			},

			getRechargeData() {
				https.post('/admin/index.php/admin/Index/dateCount', {
					type: 'recharge_record'
				}).then((res) => {
					this.loading.rechargeData = false
					if (res.data.code == 1) {
						this.rechargeData = res.data
					}
				})
			},

			getRank() {
				https.post('/admin/index.php/admin/Shop/ranking').then((res) => {
					this.loading.rankData = false
					if (res.data.code == 1) {
						this.rankData = res.data.data
					}
				})
			},

		}
	};
</script>
<style scoped="">
	.count {
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 130px;
		background: #fff;
	}
</style>
